import React, { useMemo } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import HighlightText from '@adsk/alloy-react-highlight-text';
import { DocumentEmptyIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import MalwareTooltipCell from './MalwareTooltipCell';
import { isMalwareDetected } from '../helpers/utils';

const DocumentNameCell = ({ rowData, disabledIds, rowIndicator }) => {
  const disabled = disabledIds.includes(rowData.id);

  const showMalwareIndicator = useMemo(
    () => isMalwareDetected(rowData),
    [rowData],
  );

  return (
    <Flex width="100%" data-testid="DocumentNameCell__content">
      {!rowData.folderType ? (
        <DocumentEmptyIcon
          style={{
            flex: 'none',
            marginRight: '8px',
            color: disabled && theme.colors.charcoal500,
          }}
        />
      ) : (
        <span style={{ color: disabled && theme.colors.charcoal500 }}>
          {rowData.entityIcon}
        </span>
      )}
      <Flex flexDirection="column" overflow="hidden" justifyContent="center">
        {showMalwareIndicator ? (
          <MalwareTooltipCell rowData={rowData} disabled={disabled} />
        ) : rowData.tooltipContent ? (
          <Tooltip
            content={rowData.tooltipContent}
            data-testid="DocumentNameCell__disabled-tooltip"
          >
            <HighlightText
              matched={rowData.highlight}
              text={rowData.title}
              style={{ color: theme.colors.charcoal500 }}
            />
          </Tooltip>
        ) : (
          <OverflowTooltip
            autoTipOnEllipsis
            singleLine
            content={rowData.title}
            style={{ maxWidth: '400px', wordBreak: 'break-word' }}
          >
            <HighlightText
              matched={rowData.highlight}
              text={rowData.title}
              style={{
                color: disabled && theme.colors.charcoal500,
              }}
            />
          </OverflowTooltip>
        )}
        {!!rowData.displayPath && (
          <Box color="charcoal500" overflow="hidden" marginTop="6px">
            <OverflowTooltip
              autoTipOnEllipsis
              singleLine
              content={rowData.displayPath}
              style={{ maxWidth: '400px', wordBreak: 'break-word' }}
            >
              {rowData.displayPath}
            </OverflowTooltip>
          </Box>
        )}
      </Flex>
      {rowIndicator}
    </Flex>
  );
};

export default DocumentNameCell;
